import { faArrowLeftFromLine } from "@fortawesome/pro-solid-svg-icons";
import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useIsOnline } from "@/components/graphql/useIsOnline";
import { PRIMARY_NAVIGATION_HEADER_ROW_HEIGHT } from "@/components/nav/constants";
import { useNavigationStore } from "@/components/nav/state";
import { Icon, IconButton } from "@/components/ui-v2";

import { ConnectionIndicator } from "./components/ConnectionIndicator/ConnectionIndicator";
import { WorkspaceSelectionButton } from "./components/WorkspaceSelectionButton/WorkspaceSelectionButton";

const Container = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: PRIMARY_NAVIGATION_HEADER_ROW_HEIGHT,
});

export const PrimaryNavigationHeader = () => {
  const isOnline = useIsOnline();
  const { primaryNavigationVariant, makePrimaryNavigationTemporary } =
    useNavigationStore();

  const isOfflineIndicatorVisible = !isOnline;

  return (
    <Container>
      <WorkspaceSelectionButton />
      <Stack direction="row" spacing={1}>
        {primaryNavigationVariant !== "temporary" && (
          <IconButton
            size="large"
            variant="quaternary"
            aria-label="Collapse Sidebar"
            onClick={makePrimaryNavigationTemporary}
            tooltipProps={{
              placement: "right",
            }}
            data-testid="collapse-primary-navigation"
          >
            <Icon icon={faArrowLeftFromLine} size="large" />
          </IconButton>
        )}
        {isOfflineIndicatorVisible && <ConnectionIndicator />}
      </Stack>
    </Container>
  );
};
